module.exports = __webpack_public_path__ + "static/media/tl.ed0c5593.svg";